/**
 * Hello World example component
 */
import {TweenMax} from "gsap";
const _ = require('lodash')
module.exports = function (app) {
  app.registerComponent('navigation_link', '.js-navigation-link', function (sb, el) {

 

  var onClick = function (ev) {

    var href = el.getAttribute('href')
    if (!href) return

    ev.preventDefault();

    sb.publish('navigation/collapse');

    setTimeout(function () {
      window.location.href = href
    }, 100)
    // when no fingerprint, try to get the fingerprint
    // [implement]
    // if (!app.session.fingerPrint) {

    // }
    //sb.publish('header-body/load', url)
    //console.log( app.session.fingerPrint)

  }

 

    /* INIT ------------------------------------------- */
    return {
      init: function () {
        el.addEventListener("click", onClick)
  
      },
      destroy: function () {
      }
    }
  });
}
//   TweenMax.set(div,{x:R(-200,w + 200),y:R(-500, -200),opacity:1,scale:R(.9,1)});
//   animm(div);
//  };
 
//   function animm(elm){   
//   TweenMax.to(elm,R(0,8)+3,{y:h,ease:Linear.easeNone,repeat:-1, delay:-5});
//   TweenMax.to(elm,R(0,8)+1,{x:'+=70', repeat:-1,yoyo:true,ease:Sine.easeInOut})

//       //el.addEventListener('click', onClick)
//       },
//       destroy: function () {
//         console.log('Hello World de-initialized')
//       }
//     }
//   })
// }



// WEBPACK FOOTER //
// ./assets/js/components/navigation-link.js